import React, { Component } from "react";
import TransactionTypeCards from "../TransactionTypeCards";

export default class SIPModeTypes extends Component {
  render() {
    return (
      <div className="container-margin">
        <div className="transaction-type-title">
          Select Mode of Registration
        </div>
        <div
          style={{ display: "flex", flexWrap: "wrap", marginBottom: 160 }}
          className="transt-type-whole-div"
        >
          <TransactionTypeCards
            image={"/images/mirae_new_purchase.svg"}
            name="ISIP"
            history={this.props.history}
            pan={
              !!this.props.location.state && !!this.props.location.state.pan
                ? this.props.location.state.pan
                : ""

            }
          />
          <TransactionTypeCards
            image={"/images/enach.svg"}
            name="Enach"
            history={this.props.history}
            pan={
              !!this.props.location.state && !!this.props.location.state.pan
                ? this.props.location.state.pan
                : ""
            }
          />
        </div>
      </div>
    );
  }
}
